module.exports = __webpack_public_path__ + "static/matiaswork6-04bb26a2aae7775aeb82b4016aefc286.jpg";